import { render, staticRenderFns } from "./RecentlyActive.vue?vue&type=template&id=bdeeac62&"
import script from "./RecentlyActive.vue?vue&type=script&lang=js&"
export * from "./RecentlyActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports